<template>
  <div class="sel-delega">
    <div class="select">
      <v-select v-model="searchFilter.employee" :options="deleghe" :clearable="false" label="descrizione"
        :disabled="deleghe.length <= 1"></v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'selectDeleghe',
  props: ['activateWatch', 'searchFilter'],
  watch: {},
  i18n: {
    messages: {
      it_IT: {},
      en_GB: {},
      es_ES: {},
      fr_FR: {},
      de_DE: {}
    }
  },
  data() {
    return {
      deleghe: [],
      delegaUnWatch: null
    }
  },
  beforeMount: function () {
    this.getDeleghe()
  },
  methods: {
    getDeleghe: function () {
      let _this = this
      this.$http.get('presenze/' + _this.$store.state.country + '/deleghe').then(response => {
        if (response.body.rc === 0) {
          let del = []
          for (var i = 0; i < response.body.data.length; i++) {
            let obj = {}
            obj.valore = response.body.data[i].codFisc
            obj.descrizione = response.body.data[i].cognx + ' ' + response.body.data[i].nomex
            del.push(obj)
          }
          this.deleghe = del
        }
        /*else {
         let obj = {}
         obj.valore = response.body.attrib.codFisc
         obj.descrizione = response.body.attrib.cognx + " " + response.body.attrib.nomex
         this.deleghe.push(obj)
         }*/

        if (this.deleghe.find(o => o.valore === response.body.attrib.codFisc) !== undefined) {
          this.searchFilter.employee = {
            'valore': response.body.attrib.codFisc,
            'descrizione': response.body.attrib.cognx + ' ' + response.body.attrib.nomex
          }
          this.activateWatch = false
          this.$emit('changeUser')
        } else if (this.deleghe.length === 1) {
          this.searchFilter.employee = {
            'valore': this.deleghe[0].valore,
            'descrizione': this.deleghe[0].descrizione
          }
          this.activateWatch = false
          this.$emit('changeUser')
        } else {
          this.$emit('endLoading')
        }
        this.$watch('activateWatch', function (newVal, oldVal) {
          if (newVal) {
            if (this.delegaUnWatch !== null) this.delegaUnWatch()
            this.delegaUnWatch = this.$watch('searchFilter.employee', function (newValue, oldValue) {
              this.$emit('changeUser')
            })
            this.activateWatch = false
          }
        })
        this.delegaUnWatch = this.$watch('searchFilter.employee', function (newValue, oldValue) {
          this.$emit('changeUser')
        })
      })
    }
  },
  mounted: function () {
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.sel-delega {
  float: left;
  text-align: left;

  .select {
    display: inline;
    margin-right: 10px;

    .v-select input[type=search],
    .v-select input[type=search]:focus {
      flex-basis: 20px;
      flex-grow: 1;
      height: 33px;
      padding: 0 20px 0 10px;
      width: 100% !important;
      font-size: 12px !important;
    }

    .v-select {
      background-color: white;

      .dropdown-toggle {
        border: none;
        border-radius: 0;
        border-bottom: 1px solid #e7e7e7;
        height: 22px;
        line-height: 22px;
        width: 250px;

        .selected-tag {
          //font-size: 8px !important;
          color: #606266;
          margin: 0;
          text-align: left;
          position: absolute;

          //white-space: nowrap;
          //overflow: hidden;
          .close {
            font-size: 8px !important;
          }
        }
      }

      .dropdown-menu {
        font-size: 12px; // font list
        height: 200px !important; // font list
        //flex-wrap: wrap;
      }

      &.disabled {
        background-color: white;

        .dropdown-toggle {
          background-color: white;

          input {
            height: 18px;
            border-bottom: 1px solid #e7e7e7;
            background-color: white;
            //margin: 0;
          }

          i {
            background-color: white;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PresenzeWeb/selectDelghe.vue